import { combineReducers } from 'redux';

import { catalogueReducer } from './catalogue/catalogue.reducer.ts';
import { auditLogReducer } from './reducers/auditLog.reducer.ts';
import { emailSubscriptionReducer } from './reducers/emailSubscription.reducer.ts';
import { featureFlagsReducer } from './reducers/featureFlags.reducer.ts';
import { invitationReducer } from './reducers/invitation.reducer.ts';
import { measurementPlanesReducer } from './reducers/measurementPlanes.reducer.ts';
import { notificationsReducer } from './reducers/notifications.reducer.ts';
import { projectsReducer } from './reducers/projects.reducer.ts';
import { subscriptionReducer } from './reducers/subscription.reducer.ts';
import { toastReducer } from './reducers/toast.reducer.ts';
import { uiReducer } from './reducers/ui.reducer.ts';
import { userReducer } from './reducers/user.reducer.ts';
import { workspaceReducer } from './reducers/workspace.reducer.ts';

const rootReducer = combineReducers({
  user: userReducer.reducer,
  projects: projectsReducer.reducer,
  catalogue: catalogueReducer.reducer,
  emailSubscription: emailSubscriptionReducer.reducer,
  ui: uiReducer.reducer,
  toast: toastReducer.reducer,
  workspace: workspaceReducer.reducer,
  invitation: invitationReducer.reducer,
  measurementPlanes: measurementPlanesReducer.reducer,
  featureFlags: featureFlagsReducer.reducer,
  notifications: notificationsReducer.reducer,
  subscription: subscriptionReducer.reducer,
  auditLog: auditLogReducer.reducer,
});
export default rootReducer;
